module.exports = __webpack_public_path__ + "img/32-heat-exhaustion.f8615c20.svg";